module.exports = __webpack_public_path__ + "media/images/sample/ic_microsoft@2x-05883aef8ec57717f5c6398c0b1549c2.png";